const districts = {
  'Chamkar-Mon': {
    name: 'Chamkar Mon',
    color: '#ffb74d',
    coordinates: [
      [104.898454900000004, 11.548664],
      [104.899615800000007, 11.5497725],
      [104.900899499999994, 11.5509498],
      [104.901995999999997, 11.5520119],
      [104.903114099999996, 11.553098200000001],
      [104.904754999999994, 11.5547048],
      [104.907756599999999, 11.557607600000001],
      [104.908872700000003, 11.5567148],
      [104.910735299999999, 11.555273],
      [104.911849399999994, 11.5552926],
      [104.914663099999999, 11.5553907],
      [104.916100299999997, 11.555431199999999],
      [104.917387199999993, 11.5554443],
      [104.918391900000003, 11.5554732],
      [104.919687400000001, 11.555532100000001],
      [104.920345100000006, 11.555627100000001],
      [104.922791799999999, 11.5556915],
      [104.923524499999999, 11.5557157],
      [104.925701500000002, 11.555765600000001],
      [104.926160400000001, 11.556521399999999],
      [104.927618800000005, 11.5569048],
      [104.928013199999995, 11.557155699999999],
      [104.928539000000001, 11.557093699999999],
      [104.9312209, 11.5573029],
      [104.931615199999996, 11.557301900000001],
      [104.9333302, 11.557132599999999],
      [104.933902200000006, 11.556900300000001],
      [104.934263200000004, 11.556903399999999],
      [104.934627800000001, 11.5569773],
      [104.934824300000002, 11.5570799],
      [104.935701800000004, 11.557119500000001],
      [104.939485099999999, 11.5571953],
      [104.939467300000004, 11.5577375],
      [104.939852799999997, 11.5583978],
      [104.940781900000005, 11.558953900000001],
      [104.948286100000004, 11.5597367],
      [104.947102700000002, 11.550677500000001],
      [104.9468356, 11.549429200000001],
      [104.946412600000002, 11.548508399999999],
      [104.945366800000002, 11.546719700000001],
      [104.944717499999996, 11.545870000000001],
      [104.941359599999998, 11.543139399999999],
      [104.937935999999993, 11.5417539],
      [104.935296399999999, 11.5410501],
      [104.933272000000002, 11.5399083],
      [104.931835000000007, 11.5382376],
      [104.931409000000002, 11.536035200000001],
      [104.931788299999994, 11.533977999999999],
      [104.932730599999999, 11.5315999],
      [104.930616499999999, 11.530879799999999],
      [104.928985999999995, 11.5303974],
      [104.927318400000004, 11.529713299999999],
      [104.925702700000002, 11.529014699999999],
      [104.924787800000004, 11.528597100000001],
      [104.924205499999999, 11.528331400000001],
      [104.923439400000007, 11.528020700000001],
      [104.922777999999994, 11.527752700000001],
      [104.922178799999998, 11.5274967],
      [104.921405800000002, 11.527211299999999],
      [104.920218599999998, 11.526967900000001],
      [104.918646300000006, 11.5270835],
      [104.917441999999994, 11.5274641],
      [104.915971099999993, 11.5285306],
      [104.915192200000007, 11.5296302],
      [104.914149300000005, 11.531596499999999],
      [104.913583900000006, 11.5326325],
      [104.913011499999996, 11.5337221],
      [104.912426300000007, 11.534882100000001],
      [104.911579200000006, 11.536463100000001],
      [104.910219299999994, 11.5390569],
      [104.909634600000004, 11.5401933],
      [104.908887399999998, 11.541447399999999],
      [104.908143300000006, 11.542298799999999],
      [104.907056999999995, 11.5431718],
      [104.906015800000006, 11.543631700000001],
      [104.905178399999997, 11.543819900000001],
      [104.903639900000002, 11.543971300000001],
      [104.9025429, 11.544162],
      [104.901553699999994, 11.5444874],
      [104.901024699999994, 11.5448222],
      [104.900253300000003, 11.5454077],
      [104.899469600000003, 11.546254899999999],
      [104.899118799999997, 11.5469498],
      [104.898969699999995, 11.5475668],
      [104.898830799999999, 11.548039299999999],
      [104.898963300000005, 11.5481707],
      [104.898454900000004, 11.548664],
    ],
  },
  'Doun-Penh': {
    coordinates: [
      [104.906106300000005, 11.569753800000001],
      [104.904577599999996, 11.569604699999999],
      [104.904157799999993, 11.572552699999999],
      [104.904637100000002, 11.5726309],
      [104.904609699999995, 11.572794699999999],
      [104.904070899999994, 11.5743849],
      [104.903922800000004, 11.5751039],
      [104.9041134, 11.5764938],
      [104.904547600000001, 11.5779055],
      [104.905229199999994, 11.579293099999999],
      [104.905951200000004, 11.5807752],
      [104.906720500000006, 11.5822793],
      [104.907378699999995, 11.583656100000001],
      [104.907861999999994, 11.5836913],
      [104.912974800000001, 11.585106],
      [104.91431, 11.585359800000001],
      [104.914087899999998, 11.5868544],
      [104.913920500000003, 11.5879464],
      [104.915662499999996, 11.588214300000001],
      [104.917211699999996, 11.5884657],
      [104.919401800000003, 11.588820999999999],
      [104.921940199999995, 11.5895662],
      [104.922924600000002, 11.586758400000001],
      [104.926102, 11.581331],
      [104.928611799999999, 11.577841100000001],
      [104.931372999999994, 11.5734964],
      [104.933714499999994, 11.5683857],
      [104.935344999999998, 11.566318600000001],
      [104.938593900000001, 11.563134399999999],
      [104.940250500000005, 11.562247299999999],
      [104.947845700000002, 11.562167000000001],
      [104.948387800000006, 11.560338700000001],
      [104.948870200000002, 11.559440499999999],
      [104.949938099999997, 11.5584626],
      [104.940578000000002, 11.5584037],
      [104.939912800000002, 11.558242699999999],
      [104.939523199999996, 11.5580231],
      [104.939424799999998, 11.557740799999999],
      [104.939440599999998, 11.5572006],
      [104.935701800000004, 11.557119500000001],
      [104.934824300000002, 11.5570799],
      [104.934627800000001, 11.5569773],
      [104.934263200000004, 11.556903399999999],
      [104.933902200000006, 11.556900300000001],
      [104.9333302, 11.557132599999999],
      [104.931615199999996, 11.557301900000001],
      [104.9312209, 11.5573029],
      [104.928539000000001, 11.557093699999999],
      [104.928013199999995, 11.557155699999999],
      [104.927618800000005, 11.5569048],
      [104.926160400000001, 11.556521399999999],
      [104.925701500000002, 11.555765600000001],
      [104.923524499999999, 11.5557157],
      [104.922791799999999, 11.5556915],
      [104.920345100000006, 11.555627100000001],
      [104.919862800000004, 11.5589022],
      [104.919277600000001, 11.5625097],
      [104.919064599999999, 11.5639155],
      [104.918692899999996, 11.566456000000001],
      [104.918468700000005, 11.567874],
      [104.918289999999999, 11.5690375],
      [104.917959600000003, 11.5712443],
      [104.911354200000005, 11.5702502],
      [104.908726299999998, 11.5700097],
      [104.906106300000005, 11.569753800000001],
    ],
    name: 'Daun Penh',
    color: '#ff8a65',
  },
  'Prampir-Makara': {
    coordinates: [
      [104.906106300000005, 11.569753800000001],
      [104.906792899999999, 11.5629574],
      [104.907717700000006, 11.557664000000001],
      [104.908872700000003, 11.5567148],
      [104.910769000000002, 11.5552937],
      [104.911849399999994, 11.5552926],
      [104.914666299999993, 11.5554424],
      [104.916101299999994, 11.5554624],
      [104.917346899999998, 11.555495000000001],
      [104.9183752, 11.5555459],
      [104.919696000000002, 11.555589599999999],
      [104.920351499999995, 11.555600099999999],
      [104.919862800000004, 11.5589022],
      [104.919277600000001, 11.5625097],
      [104.919064599999999, 11.5639155],
      [104.918692899999996, 11.566456000000001],
      [104.918468700000005, 11.567874],
      [104.918289999999999, 11.5690375],
      [104.917959600000003, 11.5712443],
      [104.911354200000005, 11.5702502],
      [104.908726299999998, 11.5700097],
      [104.906106300000005, 11.569753800000001],
    ],
    name: 'Prampi Makara',
    color: '#aed581',
  },
  'Tuol-Kork': {
    coordinates: [
      [104.890999199999996, 11.549873],
      [104.891476100000006, 11.5498441],
      [104.895254800000004, 11.549979199999999],
      [104.895757900000007, 11.5498615],
      [104.896253599999994, 11.5494105],
      [104.896676900000003, 11.548897],
      [104.896885499999996, 11.5487194],
      [104.897074900000007, 11.5486264],
      [104.897313100000005, 11.548718300000001],
      [104.897561499999995, 11.548765599999999],
      [104.897893499999995, 11.548794600000001],
      [104.898295300000001, 11.5486679],
      [104.898454900000004, 11.548664],
      [104.899615800000007, 11.5497725],
      [104.900899499999994, 11.5509498],
      [104.901995999999997, 11.5520119],
      [104.903114099999996, 11.553098200000001],
      [104.904754999999994, 11.5547048],
      [104.907756599999999, 11.557607600000001],
      [104.906792899999999, 11.5629574],
      [104.906106300000005, 11.569753800000001],
      [104.904577599999996, 11.569604699999999],
      [104.904157799999993, 11.572552699999999],
      [104.904637100000002, 11.5726309],
      [104.904609699999995, 11.572794699999999],
      [104.904070899999994, 11.5743849],
      [104.903922800000004, 11.5751039],
      [104.9041134, 11.5764938],
      [104.904547600000001, 11.5779055],
      [104.905229199999994, 11.579293099999999],
      [104.905951200000004, 11.5807752],
      [104.906720500000006, 11.5822793],
      [104.907378699999995, 11.583656100000001],
      [104.900684499999997, 11.5859442],
      [104.897631599999997, 11.5908613],
      [104.896517399999993, 11.5900678],
      [104.895227800000001, 11.589237499999999],
      [104.893387300000001, 11.5880299],
      [104.891409400000001, 11.5866247],
      [104.888814699999998, 11.5846661],
      [104.888182900000004, 11.583830300000001],
      [104.887785800000003, 11.583096400000001],
      [104.888316900000007, 11.5710429],
      [104.888337199999995, 11.5706677],
      [104.888392899999999, 11.5699197],
      [104.8887991, 11.5654816],
      [104.889166599999996, 11.5648509],
      [104.890045799999996, 11.563065099999999],
      [104.890815099999998, 11.561424799999999],
      [104.889906400000001, 11.560495899999999],
      [104.888751999999997, 11.559292299999999],
      [104.887805200000003, 11.557929],
      [104.887276299999996, 11.5565205],
      [104.887171100000003, 11.5559303],
      [104.887210800000005, 11.555324799999999],
      [104.887519299999994, 11.5535516],
      [104.888277299999999, 11.5520847],
      [104.888890399999994, 11.551190099999999],
      [104.889558300000004, 11.550737099999999],
      [104.890999199999996, 11.549873],
    ],
    name: 'Toul Kork',
    color: '#4fc3f7',
  },
  Dangkao: {
    coordinates: [
      [104.780059399999999, 11.4563465],
      [104.785172799999998, 11.476827],
      [104.790693399999995, 11.476734499999999],
      [104.794200799999999, 11.477584800000001],
      [104.798990099999997, 11.478757],
      [104.803117900000004, 11.481512199999999],
      [104.806340800000001, 11.481835999999999],
      [104.808602399999998, 11.4821388],
      [104.812044200000003, 11.482094699999999],
      [104.813949699999995, 11.4821577],
      [104.815095499999998, 11.4821472],
      [104.815271499999994, 11.4832617],
      [104.815531100000001, 11.4855853],
      [104.815810099999993, 11.487418999999999],
      [104.816024600000006, 11.488926599999999],
      [104.816213500000003, 11.490243],
      [104.816395900000003, 11.491773800000001],
      [104.816546099999996, 11.493005999999999],
      [104.816694100000007, 11.4938387],
      [104.816739200000001, 11.494688200000001],
      [104.816857200000001, 11.495823700000001],
      [104.816930200000002, 11.496538599999999],
      [104.817108300000001, 11.497505800000001],
      [104.817254199999994, 11.4985362],
      [104.817601800000006, 11.5005085],
      [104.819498999999993, 11.5002695],
      [104.820884599999999, 11.500148299999999],
      [104.822119299999997, 11.5001547],
      [104.824461200000002, 11.500305300000001],
      [104.827070699999993, 11.500409700000001],
      [104.829168199999998, 11.500561299999999],
      [104.830775500000001, 11.5005431],
      [104.831050300000001, 11.500525700000001],
      [104.831237999999999, 11.500514000000001],
      [104.832149799999996, 11.5004568],
      [104.833744600000003, 11.500278],
      [104.835165900000007, 11.5002709],
      [104.835864999999998, 11.500336799999999],
      [104.836528700000002, 11.5002773],
      [104.837750400000004, 11.499985199999999],
      [104.838425299999997, 11.4996375],
      [104.8384851, 11.5004642],
      [104.838442200000003, 11.5013369],
      [104.8378783, 11.5027033],
      [104.837847100000005, 11.5037263],
      [104.838654099999999, 11.505008699999999],
      [104.840094500000006, 11.5060062],
      [104.844839899999997, 11.506374599999999],
      [104.845325900000006, 11.506359399999999],
      [104.847255000000004, 11.506299],
      [104.8490532, 11.5062427],
      [104.853385399999993, 11.5057679],
      [104.8571551, 11.505633],
      [104.860692599999993, 11.506659300000001],
      [104.863212099999998, 11.508274699999999],
      [104.865579999999994, 11.5100955],
      [104.868528499999996, 11.5105185],
      [104.872557400000005, 11.5114205],
      [104.875552499999998, 11.513395600000001],
      [104.877048700000003, 11.514602399999999],
      [104.878178800000001, 11.5163574],
      [104.878256199999996, 11.516932799999999],
      [104.8780967, 11.517954700000001],
      [104.877468199999996, 11.5192952],
      [104.876559200000003, 11.520713499999999],
      [104.875482899999994, 11.521884099999999],
      [104.875512999999998, 11.5218895],
      [104.881365000000002, 11.5219848],
      [104.883741400000005, 11.5219822],
      [104.887043500000004, 11.522232199999999],
      [104.888513200000006, 11.522535700000001],
      [104.890276299999996, 11.5223216],
      [104.893942300000006, 11.5217917],
      [104.896696300000002, 11.5230196],
      [104.897363299999995, 11.5228339],
      [104.898609699999994, 11.522487],
      [104.900725100000002, 11.5219126],
      [104.904348900000002, 11.5208207],
      [104.907611900000006, 11.5199257],
      [104.910062400000001, 11.519441],
      [104.912273600000006, 11.5189574],
      [104.912983299999993, 11.5188069],
      [104.913628599999996, 11.514621999999999],
      [104.9135651, 11.5123],
      [104.913591600000004, 11.511182],
      [104.913644700000006, 11.5089188],
      [104.913703400000003, 11.5072802],
      [104.913784300000003, 11.505020999999999],
      [104.913743699999998, 11.502824499999999],
      [104.913512100000005, 11.5021688],
      [104.913522299999997, 11.4846529],
      [104.920802600000002, 11.4842142],
      [104.920126699999997, 11.482189200000001],
      [104.919437900000005, 11.4795081],
      [104.918779099999995, 11.475561000000001],
      [104.918358600000005, 11.471712800000001],
      [104.918644, 11.466257799999999],
      [104.919206799999998, 11.4633254],
      [104.921350899999993, 11.457499200000001],
      [104.9233507, 11.452168],
      [104.924666099999996, 11.449253199999999],
      [104.923288499999998, 11.448454],
      [104.923271299999996, 11.443902899999999],
      [104.923260600000006, 11.428924200000001],
      [104.922025899999994, 11.4289723],
      [104.921292600000001, 11.4290708],
      [104.919726100000005, 11.428938799999999],
      [104.918492799999996, 11.4290042],
      [104.917576199999999, 11.4288889],
      [104.9167001, 11.4300313],
      [104.915208899999996, 11.430270500000001],
      [104.913520399999996, 11.4302565],
      [104.912563800000001, 11.4310939],
      [104.913086000000007, 11.4323929],
      [104.9120834, 11.4331037],
      [104.909798800000004, 11.4343533],
      [104.907921999999999, 11.435349799999999],
      [104.905685300000002, 11.4357267],
      [104.9035662, 11.4355519],
      [104.901447300000001, 11.434985899999999],
      [104.899735500000006, 11.434995499999999],
      [104.898115899999993, 11.4354178],
      [104.896578599999998, 11.435485099999999],
      [104.894739999999999, 11.4344953],
      [104.893088300000002, 11.4333212],
      [104.891099199999999, 11.431791],
      [104.888609700000003, 11.430202899999999],
      [104.887246599999997, 11.4304997],
      [104.886381099999994, 11.432634800000001],
      [104.885167199999998, 11.4342644],
      [104.884246200000007, 11.4349299],
      [104.882765500000005, 11.4358925],
      [104.881588800000003, 11.436200599999999],
      [104.880229900000003, 11.4362201],
      [104.879578699999996, 11.435052799999999],
      [104.878839400000004, 11.433632100000001],
      [104.8774576, 11.430998900000001],
      [104.8761808, 11.4285087],
      [104.875104699999994, 11.4263613],
      [104.874146600000003, 11.4245147],
      [104.873499699999996, 11.423292699999999],
      [104.873212199999998, 11.422661700000001],
      [104.872096200000001, 11.4231397],
      [104.870487900000001, 11.423850099999999],
      [104.8688796, 11.424376199999999],
      [104.867632700000001, 11.4249262],
      [104.866770200000005, 11.425338399999999],
      [104.865837799999994, 11.4257393],
      [104.864416300000002, 11.4262541],
      [104.863903899999997, 11.4261386],
      [104.863148600000002, 11.4253333],
      [104.862218200000001, 11.424505399999999],
      [104.861251999999993, 11.4243422],
      [104.860180700000001, 11.4241574],
      [104.859377800000004, 11.4238461],
      [104.858516199999997, 11.423684],
      [104.857561000000004, 11.4238204],
      [104.856232700000007, 11.4243816],
      [104.855415699999995, 11.425334100000001],
      [104.8549589, 11.426757200000001],
      [104.854525600000002, 11.42817],
      [104.853872899999999, 11.428466999999999],
      [104.852975799999996, 11.428661],
      [104.852625099999997, 11.429373],
      [104.8521705, 11.4303495],
      [104.848698600000006, 11.4304009],
      [104.844144999999997, 11.430382699999999],
      [104.831741300000004, 11.430847200000001],
      [104.830797899999993, 11.4309145],
      [104.829957199999996, 11.4321191],
      [104.828590500000004, 11.4343001],
      [104.827480800000004, 11.436055100000001],
      [104.826802299999997, 11.437639600000001],
      [104.826787899999999, 11.439075300000001],
      [104.825571999999994, 11.4397134],
      [104.824724700000004, 11.440659500000001],
      [104.824114399999999, 11.4416949],
      [104.823650900000004, 11.4427749],
      [104.822973200000007, 11.4432756],
      [104.822140000000005, 11.4440691],
      [104.820387699999998, 11.443563599999999],
      [104.819586599999994, 11.442783500000001],
      [104.818954899999994, 11.4418922],
      [104.818018600000002, 11.4407557],
      [104.817206200000001, 11.440053499999999],
      [104.816167899999996, 11.439540600000001],
      [104.815422900000002, 11.439373099999999],
      [104.815118499999997, 11.4388272],
      [104.815525399999999, 11.4380033],
      [104.817094900000001, 11.437670199999999],
      [104.818890100000004, 11.437392900000001],
      [104.819251699999995, 11.436780600000001],
      [104.819353899999996, 11.435867399999999],
      [104.819038500000005, 11.4347981],
      [104.818418500000007, 11.4333276],
      [104.817990100000003, 11.432403000000001],
      [104.816715099999996, 11.431277400000001],
      [104.816015500000006, 11.430809200000001],
      [104.814773700000003, 11.4307862],
      [104.813801400000003, 11.430725600000001],
      [104.813125700000001, 11.4305401],
      [104.8119631, 11.4302721],
      [104.810619099999997, 11.4300046],
      [104.809716600000002, 11.430214899999999],
      [104.808293199999994, 11.4307605],
      [104.806990400000004, 11.431098799999999],
      [104.805652600000002, 11.4314144],
      [104.804838700000005, 11.431592699999999],
      [104.803822100000005, 11.4324607],
      [104.802760500000005, 11.433105899999999],
      [104.802116699999999, 11.433595499999999],
      [104.801461599999996, 11.433996],
      [104.801348000000004, 11.434976000000001],
      [104.800985800000007, 11.4363233],
      [104.800138399999994, 11.437436399999999],
      [104.799471699999998, 11.438271200000001],
      [104.798929299999998, 11.439050399999999],
      [104.798240100000001, 11.439762699999999],
      [104.797584200000003, 11.440294400000001],
      [104.797449, 11.4410031],
      [104.797685400000006, 11.4419006],
      [104.798340600000003, 11.4425151],
      [104.799118399999998, 11.4430487],
      [104.7993606, 11.4440612],
      [104.799354199999996, 11.444830700000001],
      [104.798586299999997, 11.445142000000001],
      [104.797116500000001, 11.4449086],
      [104.7963965, 11.4445502],
      [104.795595399999996, 11.443825800000001],
      [104.794906999999995, 11.4435023],
      [104.794187300000004, 11.443451700000001],
      [104.7931624, 11.443490499999999],
      [104.793009799999993, 11.4443029],
      [104.793370199999998, 11.445394500000001],
      [104.793708300000006, 11.4463414],
      [104.793233499999999, 11.447176300000001],
      [104.791455099999993, 11.4472176],
      [104.791032299999998, 11.446729299999999],
      [104.790456800000001, 11.446350199999999],
      [104.789881399999999, 11.4458041],
      [104.789193100000006, 11.445347],
      [104.788453700000005, 11.445324100000001],
      [104.787894600000001, 11.4456022],
      [104.787216799999996, 11.4461697],
      [104.786630200000005, 11.446434099999999],
      [104.785759900000002, 11.4468703],
      [104.785037200000005, 11.4470256],
      [104.784370999999993, 11.447247900000001],
      [104.783614299999996, 11.447581400000001],
      [104.783224399999995, 11.4479407],
      [104.782645099999996, 11.448632099999999],
      [104.782309999999995, 11.4492536],
      [104.782267700000006, 11.4502755],
      [104.782866400000003, 11.451211499999999],
      [104.783949399999997, 11.452248000000001],
      [104.784581099999997, 11.4529724],
      [104.785144599999995, 11.4542869],
      [104.784861800000002, 11.455043999999999],
      [104.784514200000004, 11.4554457],
      [104.783540099999996, 11.4560899],
      [104.782738600000002, 11.4560002],
      [104.782162700000001, 11.4560444],
      [104.780059399999999, 11.4563465],
    ],
    name: 'Dangkao',
    color: '#f06292',
  },
  'Mean-Chey': {
    coordinates: [
      [104.861491599999994, 11.5452709],
      [104.864051000000003, 11.5456036],
      [104.867913000000001, 11.5463413],
      [104.872205100000002, 11.547201299999999],
      [104.877242600000002, 11.547556800000001],
      [104.880276800000004, 11.5478088],
      [104.882413600000007, 11.5480693],
      [104.886160099999998, 11.548539399999999],
      [104.886710300000004, 11.5486085],
      [104.887531800000005, 11.548750399999999],
      [104.8883893, 11.548878800000001],
      [104.889322699999994, 11.549077],
      [104.890999199999996, 11.549873],
      [104.891476100000006, 11.5498441],
      [104.895254800000004, 11.549979199999999],
      [104.895757900000007, 11.5498615],
      [104.896253599999994, 11.5494105],
      [104.896676900000003, 11.548897],
      [104.896885499999996, 11.5487194],
      [104.897074900000007, 11.5486264],
      [104.897313100000005, 11.548718300000001],
      [104.897561499999995, 11.548765599999999],
      [104.897893499999995, 11.548794600000001],
      [104.898295300000001, 11.5486679],
      [104.898454900000004, 11.548664],
      [104.898963300000005, 11.5481707],
      [104.898830799999999, 11.548039299999999],
      [104.898969699999995, 11.5475668],
      [104.899118799999997, 11.5469498],
      [104.899469600000003, 11.546254899999999],
      [104.900253300000003, 11.5454077],
      [104.901024699999994, 11.5448222],
      [104.901553699999994, 11.5444874],
      [104.9025429, 11.544162],
      [104.903639900000002, 11.543971300000001],
      [104.905178399999997, 11.543819900000001],
      [104.906015800000006, 11.543631700000001],
      [104.907056999999995, 11.5431718],
      [104.908143300000006, 11.542298799999999],
      [104.908887399999998, 11.541447399999999],
      [104.909634600000004, 11.5401933],
      [104.910219299999994, 11.5390569],
      [104.911579200000006, 11.536463100000001],
      [104.912426300000007, 11.534882100000001],
      [104.913011499999996, 11.5337221],
      [104.913583900000006, 11.5326325],
      [104.914149300000005, 11.531596499999999],
      [104.915192200000007, 11.5296302],
      [104.915971099999993, 11.5285306],
      [104.917441999999994, 11.5274641],
      [104.918646300000006, 11.5270835],
      [104.920218599999998, 11.526967900000001],
      [104.921405800000002, 11.527211299999999],
      [104.922178799999998, 11.5274967],
      [104.922777999999994, 11.527752700000001],
      [104.923439400000007, 11.528020700000001],
      [104.924205499999999, 11.528331400000001],
      [104.924787800000004, 11.528597100000001],
      [104.925702700000002, 11.529014699999999],
      [104.927318400000004, 11.529713299999999],
      [104.928985999999995, 11.5303974],
      [104.930616499999999, 11.530879799999999],
      [104.932730599999999, 11.5315999],
      [104.935755999999998, 11.524108999999999],
      [104.946337900000003, 11.4946255],
      [104.935685699999993, 11.489730399999999],
      [104.926319699999993, 11.485004],
      [104.920802600000002, 11.4842142],
      [104.913522299999997, 11.4846529],
      [104.913512100000005, 11.5021688],
      [104.913743699999998, 11.502824499999999],
      [104.913784300000003, 11.505020999999999],
      [104.913703400000003, 11.5072802],
      [104.913644700000006, 11.5089188],
      [104.913591600000004, 11.511182],
      [104.9135651, 11.5123],
      [104.913628599999996, 11.514621999999999],
      [104.912983299999993, 11.5188069],
      [104.912273600000006, 11.5189574],
      [104.910062400000001, 11.519441],
      [104.907611900000006, 11.5199257],
      [104.904348900000002, 11.5208207],
      [104.900725100000002, 11.5219126],
      [104.898609699999994, 11.522487],
      [104.897363299999995, 11.5228339],
      [104.896696300000002, 11.5230196],
      [104.893942300000006, 11.5217917],
      [104.890276299999996, 11.5223216],
      [104.888513200000006, 11.522535700000001],
      [104.887043500000004, 11.522232199999999],
      [104.883741400000005, 11.5219822],
      [104.881365000000002, 11.5219848],
      [104.875512999999998, 11.5218895],
      [104.875482899999994, 11.521884099999999],
      [104.874860299999995, 11.521773899999999],
      [104.872280200000006, 11.521985300000001],
      [104.868734900000007, 11.5219589],
      [104.862920500000001, 11.5218556],
      [104.862846500000003, 11.523188299999999],
      [104.862818799999999, 11.5246037],
      [104.862701799999996, 11.5260449],
      [104.862352200000004, 11.529222000000001],
      [104.862165099999999, 11.5323628],
      [104.862144799999996, 11.535215000000001],
      [104.861998400000004, 11.5376326],
      [104.8617919, 11.5400317],
      [104.8614453, 11.542675600000001],
      [104.8614046, 11.5445499],
      [104.861491599999994, 11.5452709],
    ],
    name: 'Mean Chey',
    color: '#81c784',
  },
  'Russey-Keo': {
    coordinates: [
      [104.858487800000006, 11.650827],
      [104.872647900000004, 11.6289169],
      [104.876213699999994, 11.6219255],
      [104.885141099999998, 11.608095499999999],
      [104.886837400000005, 11.605142300000001],
      [104.887708900000007, 11.604357500000001],
      [104.889182000000005, 11.6038047],
      [104.891232400000007, 11.6033773],
      [104.896517399999993, 11.5900678],
      [104.897631599999997, 11.5908613],
      [104.900684499999997, 11.5859442],
      [104.907378699999995, 11.583656100000001],
      [104.907861999999994, 11.5836913],
      [104.912974800000001, 11.585106],
      [104.91431, 11.585359800000001],
      [104.914087899999998, 11.5868544],
      [104.913920500000003, 11.5879464],
      [104.915662499999996, 11.588214300000001],
      [104.917211699999996, 11.5884657],
      [104.919401800000003, 11.588820999999999],
      [104.921940199999995, 11.5895662],
      [104.921458999999999, 11.5937135],
      [104.921407500000001, 11.596012999999999],
      [104.921395200000006, 11.597573199999999],
      [104.921386100000007, 11.598507],
      [104.921405399999998, 11.6024534],
      [104.921404300000006, 11.6044654],
      [104.921393600000002, 11.606189499999999],
      [104.921395700000005, 11.607670300000001],
      [104.921392499999996, 11.6089083],
      [104.921407000000002, 11.610593],
      [104.9213673, 11.611352800000001],
      [104.920612000000006, 11.6136927],
      [104.920121100000003, 11.614975299999999],
      [104.919622799999999, 11.615949499999999],
      [104.918221399999993, 11.618276099999999],
      [104.916517999999996, 11.621336899999999],
      [104.914450400000007, 11.6247376],
      [104.912498799999995, 11.6266801],
      [104.910224799999995, 11.629034600000001],
      [104.908285100000001, 11.6310281],
      [104.906766899999994, 11.632197700000001],
      [104.905386100000001, 11.6333216],
      [104.902638499999995, 11.6354395],
      [104.900834399999994, 11.6361515],
      [104.897972499999995, 11.6372438],
      [104.895937799999999, 11.6380225],
      [104.894469599999994, 11.638620899999999],
      [104.892001899999997, 11.6395803],
      [104.888825100000005, 11.6408129],
      [104.887573099999997, 11.6412984],
      [104.885592500000001, 11.642171599999999],
      [104.883021900000003, 11.643583899999999],
      [104.877625300000005, 11.6467384],
      [104.876804500000006, 11.6476799],
      [104.875430199999997, 11.649155199999999],
      [104.873321899999993, 11.6515773],
      [104.870924000000002, 11.654155899999999],
      [104.870030299999996, 11.6555366],
      [104.868811500000007, 11.6573349],
      [104.868025099999997, 11.658568000000001],
      [104.860569699999999, 11.653328],
      [104.858074700000003, 11.6514884],
      [104.858487800000006, 11.650827],
    ],
    name: 'Russey Keo',
    color: '#a1887f',
  },
  'Sen-Sok': {
    coordinates: [
      [104.823370400000002, 11.5794479],
      [104.824247999999997, 11.580006900000001],
      [104.824698799999993, 11.580481900000001],
      [104.826096300000003, 11.582080100000001],
      [104.827540600000006, 11.5836557],
      [104.830003899999994, 11.5861362],
      [104.831509499999996, 11.588666999999999],
      [104.832142500000003, 11.5909136],
      [104.832577499999999, 11.593077600000001],
      [104.833005999999997, 11.595943500000001],
      [104.832480899999993, 11.5996974],
      [104.832409100000007, 11.602408199999999],
      [104.832892400000006, 11.605676600000001],
      [104.832740799999996, 11.6094455],
      [104.832832699999997, 11.6121123],
      [104.833908600000001, 11.614432600000001],
      [104.835036299999999, 11.617430000000001],
      [104.835922499999995, 11.618805200000001],
      [104.837632400000004, 11.6194867],
      [104.838748100000004, 11.620543],
      [104.8361369, 11.6341921],
      [104.842674500000001, 11.639216100000001],
      [104.854990700000002, 11.6483376],
      [104.858487800000006, 11.650827],
      [104.872647900000004, 11.6289169],
      [104.876213699999994, 11.6219255],
      [104.885141099999998, 11.608095499999999],
      [104.886837400000005, 11.605142300000001],
      [104.887708900000007, 11.604357500000001],
      [104.889182000000005, 11.6038047],
      [104.891232400000007, 11.6033773],
      [104.896517399999993, 11.5900678],
      [104.895227800000001, 11.589237499999999],
      [104.893387300000001, 11.5880299],
      [104.891409400000001, 11.5866247],
      [104.888814699999998, 11.5846661],
      [104.888182900000004, 11.583830300000001],
      [104.887785800000003, 11.583096400000001],
      [104.888316900000007, 11.5710429],
      [104.888337199999995, 11.5706677],
      [104.888392899999999, 11.5699197],
      [104.8887991, 11.5654816],
      [104.889166599999996, 11.5648509],
      [104.890045799999996, 11.563065099999999],
      [104.890815099999998, 11.561424799999999],
      [104.889906400000001, 11.560495899999999],
      [104.888751999999997, 11.559292299999999],
      [104.887805200000003, 11.557929],
      [104.887276299999996, 11.5565205],
      [104.887171100000003, 11.5559303],
      [104.887210800000005, 11.555324799999999],
      [104.887519299999994, 11.5535516],
      [104.888277299999999, 11.5520847],
      [104.888890399999994, 11.551190099999999],
      [104.889558300000004, 11.550737099999999],
      [104.890999199999996, 11.549873],
      [104.889322699999994, 11.549077],
      [104.8883893, 11.548878800000001],
      [104.887531800000005, 11.548750399999999],
      [104.886710300000004, 11.5486085],
      [104.886160099999998, 11.548539399999999],
      [104.882413600000007, 11.5480693],
      [104.880276800000004, 11.5478088],
      [104.877242600000002, 11.547556800000001],
      [104.872205100000002, 11.547201299999999],
      [104.867913000000001, 11.5463413],
      [104.864051000000003, 11.5456036],
      [104.861491599999994, 11.5452709],
      [104.861596500000005, 11.5458184],
      [104.862762599999996, 11.5548106],
      [104.862908500000003, 11.560652899999999],
      [104.864247800000001, 11.567443300000001],
      [104.864288099999996, 11.567647600000001],
      [104.862642600000001, 11.567550799999999],
      [104.8607169, 11.5673735],
      [104.858791800000006, 11.5671374],
      [104.856119899999996, 11.566693000000001],
      [104.853319200000001, 11.566420300000001],
      [104.850553099999999, 11.5663205],
      [104.834778799999995, 11.566548299999999],
      [104.834803699999995, 11.5679914],
      [104.833471500000002, 11.5682718],
      [104.831819899999999, 11.568358099999999],
      [104.827305600000003, 11.568940599999999],
      [104.824949399999994, 11.5691779],
      [104.823617100000007, 11.568573799999999],
      [104.823370400000002, 11.5794479],
    ],
    name: 'Sen Sok',
    color: '#90a4ae',
  },
  'Por-Senchey': {
    coordinates: [
      [104.734679900000003, 11.58151],
      [104.734340099999997, 11.5834043],
      [104.733930999999998, 11.584437100000001],
      [104.733346600000004, 11.585585099999999],
      [104.732832700000003, 11.586446],
      [104.732411799999994, 11.5874337],
      [104.732072700000003, 11.5884214],
      [104.731721899999997, 11.5895119],
      [104.731558100000001, 11.5903042],
      [104.7315921, 11.5918993],
      [104.732384600000003, 11.5934589],
      [104.7335274, 11.594778099999999],
      [104.734285299999996, 11.595947600000001],
      [104.734658600000003, 11.5964183],
      [104.735276499999998, 11.5975074],
      [104.735731099999995, 11.5983681],
      [104.7360106, 11.5992976],
      [104.736091200000004, 11.600835099999999],
      [104.735693699999999, 11.601903],
      [104.735331599999995, 11.6025572],
      [104.734501499999993, 11.6046353],
      [104.734442299999998, 11.6057714],
      [104.734430099999997, 11.6068046],
      [104.734790799999999, 11.6081807],
      [104.735956700000003, 11.6106246],
      [104.737436599999995, 11.6141009],
      [104.738415900000007, 11.6161999],
      [104.739266499999999, 11.6183101],
      [104.739674300000004, 11.6194115],
      [104.740186899999998, 11.6211789],
      [104.740547100000001, 11.6235192],
      [104.740860999999995, 11.625665100000001],
      [104.741617000000005, 11.628403],
      [104.741653099999994, 11.6285337],
      [104.741833999999997, 11.629448399999999],
      [104.742583400000001, 11.634121199999999],
      [104.742908999999997, 11.6357053],
      [104.743875799999998, 11.6393428],
      [104.743699199999995, 11.641879299999999],
      [104.743359699999999, 11.6435543],
      [104.743020000000001, 11.6453107],
      [104.742715500000003, 11.6465969],
      [104.742491700000002, 11.648010899999999],
      [104.746176000000006, 11.6531837],
      [104.746955499999999, 11.653295099999999],
      [104.747789999999995, 11.6553194],
      [104.748102799999998, 11.6566487],
      [104.750021899999993, 11.656081500000001],
      [104.754195199999998, 11.6557715],
      [104.758559300000002, 11.6551992],
      [104.760967899999997, 11.6550799],
      [104.763972699999997, 11.6542691],
      [104.769720000000007, 11.6518605],
      [104.772009299999993, 11.6513597],
      [104.775681800000001, 11.651073500000001],
      [104.7816914, 11.648569500000001],
      [104.787295599999993, 11.647067099999999],
      [104.790467300000003, 11.647114800000001],
      [104.791731299999995, 11.6466379],
      [104.798837800000001, 11.6465902],
      [104.799553299999999, 11.6461132],
      [104.802248000000006, 11.646065500000001],
      [104.802868099999998, 11.6463994],
      [104.802915799999994, 11.646947900000001],
      [104.804179700000006, 11.647353300000001],
      [104.805586700000006, 11.647377199999999],
      [104.806087500000004, 11.647830300000001],
      [104.804632799999993, 11.648998799999999],
      [104.804489700000005, 11.649881199999999],
      [104.805538999999996, 11.651264299999999],
      [104.807041400000003, 11.6514074],
      [104.807637600000007, 11.6518128],
      [104.809688499999993, 11.651789000000001],
      [104.810785499999994, 11.6506443],
      [104.811882400000002, 11.6505966],
      [104.812359400000005, 11.6514074],
      [104.812263999999999, 11.652075099999999],
      [104.812287900000001, 11.652718999999999],
      [104.812573999999998, 11.653195999999999],
      [104.815221100000002, 11.6509781],
      [104.8157219, 11.651550500000001],
      [104.816675799999999, 11.652790599999999],
      [104.816604299999995, 11.6537445],
      [104.814982599999993, 11.6552945],
      [104.815078, 11.656033799999999],
      [104.815817300000006, 11.656319999999999],
      [104.8163658, 11.656033799999999],
      [104.817534300000005, 11.655866899999999],
      [104.817987400000007, 11.6559861],
      [104.817892000000001, 11.6564154],
      [104.817558199999993, 11.656892300000001],
      [104.817534300000005, 11.657750800000001],
      [104.817939699999997, 11.658871700000001],
      [104.818225900000002, 11.659205500000001],
      [104.818655100000001, 11.6589194],
      [104.819132100000004, 11.6589432],
      [104.820324499999998, 11.6572739],
      [104.820682199999993, 11.6572262],
      [104.821349900000001, 11.6577985],
      [104.821230700000001, 11.6604218],
      [104.821493000000004, 11.660898700000001],
      [104.822256100000004, 11.660898700000001],
      [104.823710800000001, 11.657989300000001],
      [104.824283199999996, 11.6574647],
      [104.824712399999996, 11.6574408],
      [104.825451700000002, 11.657941599999999],
      [104.827001800000005, 11.657774699999999],
      [104.827073299999995, 11.6564631],
      [104.826787199999998, 11.655723800000001],
      [104.826119399999996, 11.6551276],
      [104.824831700000004, 11.654817599999999],
      [104.824378600000003, 11.6542691],
      [104.823520099999996, 11.6534821],
      [104.823520099999996, 11.652885899999999],
      [104.824330900000007, 11.6521705],
      [104.825833299999999, 11.652099],
      [104.827216399999998, 11.6497381],
      [104.8292912, 11.647401],
      [104.830340500000005, 11.6469241],
      [104.830865099999997, 11.646947900000001],
      [104.831580500000001, 11.6472818],
      [104.836063899999999, 11.6494996],
      [104.837280100000001, 11.649595],
      [104.838973300000006, 11.6487842],
      [104.840260999999998, 11.649213400000001],
      [104.840237200000004, 11.650024200000001],
      [104.840022599999998, 11.6507158],
      [104.839807899999997, 11.6516936],
      [104.840046400000006, 11.6528144],
      [104.840499500000007, 11.653362899999999],
      [104.841978100000006, 11.6536729],
      [104.842216500000006, 11.645517099999999],
      [104.842505099999997, 11.6390859],
      [104.8361369, 11.6341921],
      [104.838748100000004, 11.620543],
      [104.841879700000007, 11.593958600000001],
      [104.844431400000005, 11.575703300000001],
      [104.834808899999999, 11.572865500000001],
      [104.834803699999995, 11.5679914],
      [104.834778799999995, 11.566548299999999],
      [104.850553099999999, 11.5663205],
      [104.853319200000001, 11.566420300000001],
      [104.856119899999996, 11.566693000000001],
      [104.858791800000006, 11.5671374],
      [104.8607169, 11.5673735],
      [104.862642600000001, 11.567550799999999],
      [104.864288099999996, 11.567647600000001],
      [104.864256800000007, 11.567436499999999],
      [104.862908500000003, 11.560652899999999],
      [104.862762599999996, 11.5548106],
      [104.8614192, 11.546131000000001],
      [104.8614046, 11.5445499],
      [104.8614453, 11.542675600000001],
      [104.861998400000004, 11.5376326],
      [104.862144799999996, 11.535215000000001],
      [104.862165099999999, 11.5323628],
      [104.862352200000004, 11.529222000000001],
      [104.862701799999996, 11.5260449],
      [104.862818799999999, 11.5246037],
      [104.862846500000003, 11.523188299999999],
      [104.862920500000001, 11.5218556],
      [104.868734900000007, 11.5219589],
      [104.872280200000006, 11.521985300000001],
      [104.874860299999995, 11.521773899999999],
      [104.875482899999994, 11.521884099999999],
      [104.876559200000003, 11.520713499999999],
      [104.877468199999996, 11.5192952],
      [104.878021599999997, 11.517868],
      [104.878256199999996, 11.516932799999999],
      [104.878178800000001, 11.5163574],
      [104.877048700000003, 11.514602399999999],
      [104.875552499999998, 11.513395600000001],
      [104.872557400000005, 11.5114205],
      [104.868528499999996, 11.5105185],
      [104.865579999999994, 11.5100955],
      [104.863212099999998, 11.508274699999999],
      [104.860692599999993, 11.506659300000001],
      [104.8571551, 11.505633],
      [104.853385399999993, 11.5057679],
      [104.8490532, 11.5062427],
      [104.845325900000006, 11.506359399999999],
      [104.844839899999997, 11.506374599999999],
      [104.840094500000006, 11.5060062],
      [104.838654099999999, 11.505008699999999],
      [104.837847100000005, 11.5037263],
      [104.8378783, 11.5027033],
      [104.838442200000003, 11.5013369],
      [104.8384851, 11.5004642],
      [104.838425299999997, 11.4996375],
      [104.837750400000004, 11.499985199999999],
      [104.836528700000002, 11.5002773],
      [104.835864999999998, 11.500336799999999],
      [104.835165900000007, 11.5002709],
      [104.833744600000003, 11.500278],
      [104.832149799999996, 11.5004568],
      [104.831237999999999, 11.500514000000001],
      [104.831050300000001, 11.500525700000001],
      [104.830775500000001, 11.5005431],
      [104.829168199999998, 11.500561299999999],
      [104.827070699999993, 11.500409700000001],
      [104.824461200000002, 11.500305300000001],
      [104.822119299999997, 11.5001547],
      [104.820884599999999, 11.500148299999999],
      [104.819498999999993, 11.5002695],
      [104.817601800000006, 11.5005085],
      [104.817254199999994, 11.4985362],
      [104.817108300000001, 11.497505800000001],
      [104.816930200000002, 11.496538599999999],
      [104.816857200000001, 11.495823700000001],
      [104.816739200000001, 11.494688200000001],
      [104.816694100000007, 11.4938387],
      [104.816546099999996, 11.493005999999999],
      [104.816395900000003, 11.491773800000001],
      [104.816213500000003, 11.490243],
      [104.816024600000006, 11.488926599999999],
      [104.815810099999993, 11.487418999999999],
      [104.815531100000001, 11.4855853],
      [104.815271499999994, 11.4832617],
      [104.815095499999998, 11.4821472],
      [104.813949699999995, 11.4821577],
      [104.812044200000003, 11.482094699999999],
      [104.808602399999998, 11.4821388],
      [104.806340800000001, 11.481835999999999],
      [104.803117900000004, 11.481512199999999],
      [104.798990099999997, 11.478757],
      [104.794200799999999, 11.477584800000001],
      [104.790693399999995, 11.476734499999999],
      [104.785172799999998, 11.476827],
      [104.780059399999999, 11.4563465],
      [104.779670899999999, 11.4557982],
      [104.778694099999996, 11.456204400000001],
      [104.777975999999995, 11.457102600000001],
      [104.777814699999993, 11.4578007],
      [104.777283999999995, 11.4578671],
      [104.776358500000001, 11.4574432],
      [104.775041999999999, 11.4573445],
      [104.774251800000002, 11.4577384],
      [104.773929899999999, 11.458933699999999],
      [104.774042100000003, 11.459924900000001],
      [104.774232999999995, 11.4611836],
      [104.774683800000005, 11.4621528],
      [104.775778700000004, 11.463484599999999],
      [104.777313100000001, 11.463958999999999],
      [104.778825600000005, 11.464517000000001],
      [104.7789942, 11.4653858],
      [104.778451599999997, 11.466332],
      [104.777333299999995, 11.4669548],
      [104.776385099999999, 11.466731299999999],
      [104.775482699999998, 11.4657061],
      [104.7741173, 11.464669300000001],
      [104.773202499999996, 11.4629558],
      [104.772442900000001, 11.462327800000001],
      [104.771381099999999, 11.4618725],
      [104.770274400000005, 11.461808400000001],
      [104.7691856, 11.461959200000001],
      [104.767818599999998, 11.4629938],
      [104.766869799999995, 11.4635499],
      [104.765717499999994, 11.4638475],
      [104.764353600000007, 11.463543400000001],
      [104.763616299999995, 11.462730000000001],
      [104.7642405, 11.4618327],
      [104.764997800000003, 11.460819900000001],
      [104.765506900000005, 11.4596064],
      [104.7649373, 11.4583268],
      [104.764097300000003, 11.4575338],
      [104.762929, 11.4571405],
      [104.760309100000001, 11.4572661],
      [104.759185500000001, 11.4582426],
      [104.758326800000006, 11.4589546],
      [104.756880199999998, 11.458910299999999],
      [104.755641400000002, 11.4578478],
      [104.755743499999994, 11.4565135],
      [104.757540000000006, 11.454900200000001],
      [104.759358599999999, 11.453787999999999],
      [104.760240199999998, 11.4526194],
      [104.760252500000007, 11.4513943],
      [104.759383900000003, 11.450547200000001],
      [104.757837300000006, 11.4504568],
      [104.755159199999994, 11.4511664],
      [104.754387500000007, 11.4518852],
      [104.753895099999994, 11.452769999999999],
      [104.753814700000007, 11.4543625],
      [104.754084500000005, 11.455754799999999],
      [104.752828800000003, 11.4564471],
      [104.751633799999993, 11.456588],
      [104.750494099999997, 11.45593],
      [104.749625100000003, 11.4555729],
      [104.748666099999994, 11.4552339],
      [104.747976399999999, 11.454674900000001],
      [104.746939400000002, 11.454529300000001],
      [104.746287699999996, 11.4547571],
      [104.745556699999995, 11.454891],
      [104.745000300000001, 11.454667799999999],
      [104.7442961, 11.4545903],
      [104.744472799999997, 11.455899499999999],
      [104.744474499999995, 11.4569463],
      [104.744740300000004, 11.459569200000001],
      [104.744752199999994, 11.4619941],
      [104.7446518, 11.4639813],
      [104.744689100000002, 11.466189099999999],
      [104.744831899999994, 11.468294200000001],
      [104.744877099999997, 11.470868299999999],
      [104.744878499999999, 11.4731676],
      [104.7448373, 11.4750633],
      [104.744901900000002, 11.4780297],
      [104.746265800000003, 11.478972600000001],
      [104.746361300000004, 11.481169100000001],
      [104.746302799999995, 11.483747599999999],
      [104.748368299999996, 11.4845408],
      [104.748592599999995, 11.4852633],
      [104.748538600000003, 11.4863202],
      [104.749727100000001, 11.4864309],
      [104.749942799999999, 11.4878193],
      [104.749831599999993, 11.489152000000001],
      [104.750483799999998, 11.489126600000001],
      [104.7516131, 11.4890066],
      [104.754024299999998, 11.488997299999999],
      [104.756865700000006, 11.4888821],
      [104.758450199999999, 11.4889908],
      [104.758639099999996, 11.4895528],
      [104.758923499999995, 11.490734399999999],
      [104.758891599999998, 11.491469199999999],
      [104.760463700000003, 11.491394700000001],
      [104.762689800000004, 11.49173],
      [104.762949399999997, 11.4924865],
      [104.762838700000003, 11.493865599999999],
      [104.762831300000002, 11.494921400000001],
      [104.762868900000001, 11.495530799999999],
      [104.763080700000003, 11.496080299999999],
      [104.763678400000003, 11.496904900000001],
      [104.764463699999993, 11.4980507],
      [104.7650747, 11.4993456],
      [104.765964699999998, 11.500421299999999],
      [104.766724100000005, 11.501004099999999],
      [104.767506600000004, 11.5014603],
      [104.768103199999999, 11.502112],
      [104.768206699999993, 11.5038179],
      [104.768455700000004, 11.505982899999999],
      [104.768588699999995, 11.5080902],
      [104.768605899999997, 11.5101262],
      [104.768428700000001, 11.5126876],
      [104.768472500000001, 11.5145179],
      [104.768305900000001, 11.516355799999999],
      [104.768178599999999, 11.5186087],
      [104.767556999999996, 11.518910099999999],
      [104.766061199999996, 11.519855099999999],
      [104.764650700000004, 11.5205492],
      [104.762488500000003, 11.5223821],
      [104.761259300000006, 11.523347899999999],
      [104.761107100000004, 11.523467399999999],
      [104.759210899999999, 11.5254543],
      [104.757725399999998, 11.5272968],
      [104.756798700000004, 11.529228],
      [104.755992599999999, 11.5309071],
      [104.754746100000006, 11.5307399],
      [104.752870099999996, 11.5297254],
      [104.750854700000005, 11.528662199999999],
      [104.748734400000004, 11.527597800000001],
      [104.747208999999998, 11.5281628],
      [104.745763699999998, 11.5286375],
      [104.745005000000006, 11.5291195],
      [104.744363000000007, 11.529809699999999],
      [104.744140299999998, 11.531083499999999],
      [104.744093199999995, 11.5321856],
      [104.743788800000004, 11.533780399999999],
      [104.743496500000006, 11.5347218],
      [104.743001399999997, 11.535242500000001],
      [104.742690300000007, 11.536294699999999],
      [104.7436498, 11.538250100000001],
      [104.743447500000002, 11.5410647],
      [104.742581400000006, 11.5429417],
      [104.741112200000003, 11.544648499999999],
      [104.739757600000004, 11.5457675],
      [104.738552100000007, 11.5458512],
      [104.737217099999995, 11.5449106],
      [104.735394400000004, 11.543671099999999],
      [104.733806299999998, 11.5438008],
      [104.732125400000001, 11.543827500000001],
      [104.730479900000006, 11.544268000000001],
      [104.728949299999996, 11.5441682],
      [104.727905699999994, 11.5440553],
      [104.727931799999993, 11.5457816],
      [104.727750799999995, 11.5483475],
      [104.727360599999997, 11.550500599999999],
      [104.726864699999993, 11.5520896],
      [104.726277199999998, 11.554150999999999],
      [104.725411199999996, 11.556328499999999],
      [104.724556199999995, 11.557952200000001],
      [104.723144399999995, 11.559370700000001],
      [104.721858699999999, 11.560144899999999],
      [104.720619099999993, 11.5608141],
      [104.719358099999994, 11.562394400000001],
      [104.722154900000007, 11.563860999999999],
      [104.722991699999994, 11.564859999999999],
      [104.723412100000004, 11.566620500000001],
      [104.723042300000003, 11.567311999999999],
      [104.722011100000003, 11.567785799999999],
      [104.721305099999995, 11.568454300000001],
      [104.721448100000003, 11.570778600000001],
      [104.721415800000003, 11.57216],
      [104.719490899999997, 11.5721062],
      [104.717392099999998, 11.571995599999999],
      [104.715548499999997, 11.5720458],
      [104.714145900000005, 11.5722208],
      [104.713196199999999, 11.5728902],
      [104.712664799999999, 11.5740303],
      [104.712957099999997, 11.5754459],
      [104.714268200000006, 11.5759378],
      [104.716285799999994, 11.5759454],
      [104.717839600000005, 11.5759074],
      [104.719242399999999, 11.575812600000001],
      [104.720562900000004, 11.5750045],
      [104.722640400000003, 11.5745883],
      [104.7232281, 11.5747844],
      [104.724145699999994, 11.574973999999999],
      [104.7250516, 11.575950499999999],
      [104.726141100000007, 11.575298099999999],
      [104.727332000000004, 11.574733999999999],
      [104.728417399999998, 11.574480700000001],
      [104.728887900000004, 11.5749751],
      [104.7295953, 11.5758112],
      [104.730085000000003, 11.5763497],
      [104.730493300000006, 11.576774],
      [104.731157899999999, 11.577439399999999],
      [104.731869200000006, 11.5784258],
      [104.732300300000006, 11.5794006],
      [104.7327315, 11.5804557],
      [104.732987899999998, 11.5811896],
      [104.733886400000003, 11.581303500000001],
      [104.734679900000003, 11.58151],
    ],
    name: 'Pou Senchey',
    color: '#7986cb',
  },
  'Chroy-Changvar': {
    coordinates: [
      [104.860137800000004, 11.670337699999999],
      [104.862002899999993, 11.667774700000001],
      [104.864000599999997, 11.6646052],
      [104.866219400000006, 11.6611742],
      [104.868025099999997, 11.658568000000001],
      [104.868811500000007, 11.6573349],
      [104.870030299999996, 11.6555366],
      [104.870924000000002, 11.654155899999999],
      [104.873321899999993, 11.6515773],
      [104.875430199999997, 11.649155199999999],
      [104.876804500000006, 11.6476799],
      [104.877625300000005, 11.6467384],
      [104.883021900000003, 11.643583899999999],
      [104.885592500000001, 11.642171599999999],
      [104.887573099999997, 11.6412984],
      [104.888825100000005, 11.6408129],
      [104.892001899999997, 11.6395803],
      [104.894469599999994, 11.638620899999999],
      [104.895937799999999, 11.6380225],
      [104.897972499999995, 11.6372438],
      [104.900834399999994, 11.6361515],
      [104.902638499999995, 11.6354395],
      [104.905386100000001, 11.6333216],
      [104.906766899999994, 11.632197700000001],
      [104.908285100000001, 11.6310281],
      [104.910224799999995, 11.629034600000001],
      [104.912498799999995, 11.6266801],
      [104.914450400000007, 11.6247376],
      [104.916517999999996, 11.621336899999999],
      [104.918221399999993, 11.618276099999999],
      [104.919622799999999, 11.615949499999999],
      [104.920121100000003, 11.614975299999999],
      [104.920612000000006, 11.6136927],
      [104.9213673, 11.611352800000001],
      [104.921407000000002, 11.610593],
      [104.921392499999996, 11.6089083],
      [104.921395700000005, 11.607670300000001],
      [104.921393600000002, 11.606189499999999],
      [104.921404300000006, 11.6044654],
      [104.921405399999998, 11.6024534],
      [104.921386100000007, 11.598507],
      [104.921395200000006, 11.597573199999999],
      [104.921407500000001, 11.596012999999999],
      [104.921458999999999, 11.5937135],
      [104.921940199999995, 11.5895662],
      [104.922924600000002, 11.586758400000001],
      [104.926102, 11.581331],
      [104.928611799999999, 11.577841100000001],
      [104.931372999999994, 11.5734964],
      [104.933714499999994, 11.5683857],
      [104.935344999999998, 11.566318600000001],
      [104.938593900000001, 11.563134399999999],
      [104.940250500000005, 11.562247299999999],
      [104.947845700000002, 11.562167000000001],
      [104.945666799999998, 11.5696789],
      [104.943752700000005, 11.5867316],
      [104.940353900000005, 11.598781300000001],
      [104.933973399999999, 11.614205],
      [104.933254700000006, 11.6193528],
      [104.933134800000005, 11.6211787],
      [104.933136899999994, 11.6228391],
      [104.933211999999997, 11.624722200000001],
      [104.933411599999999, 11.627541000000001],
      [104.933896899999993, 11.631066300000001],
      [104.934590400000005, 11.6339247],
      [104.936132700000002, 11.639074600000001],
      [104.937556599999994, 11.6423519],
      [104.939930500000003, 11.645512399999999],
      [104.941764000000006, 11.648161999999999],
      [104.943922799999996, 11.6516284],
      [104.945940699999994, 11.654335],
      [104.947246100000001, 11.655164900000001],
      [104.950686899999994, 11.665881600000001],
      [104.951728299999999, 11.668694800000001],
      [104.952860400000006, 11.6711507],
      [104.9544906, 11.674990899999999],
      [104.956347500000007, 11.6777149],
      [104.957162800000006, 11.6785187],
      [104.959121800000005, 11.679847000000001],
      [104.959839900000006, 11.6828235],
      [104.961006699999999, 11.686277199999999],
      [104.962160400000002, 11.689858600000001],
      [104.963173299999994, 11.695174099999999],
      [104.964307500000004, 11.699306099999999],
      [104.965465399999999, 11.703415400000001],
      [104.966914799999998, 11.7075756],
      [104.968114, 11.710386],
      [104.967556000000002, 11.711490299999999],
      [104.959009399999999, 11.715063799999999],
      [104.957307, 11.716127500000001],
      [104.953054100000003, 11.718291600000001],
      [104.950998499999997, 11.720018700000001],
      [104.948736800000006, 11.7217793],
      [104.947376399999996, 11.7224054],
      [104.944792899999996, 11.723603000000001],
      [104.942578499999996, 11.7247754],
      [104.940591499999996, 11.7252586],
      [104.938673199999997, 11.7257838],
      [104.936960900000003, 11.7258301],
      [104.9353859, 11.725834300000001],
      [104.933828000000005, 11.725792200000001],
      [104.931742400000005, 11.7258637],
      [104.929935599999993, 11.7260612],
      [104.928364900000005, 11.7255821],
      [104.926935999999998, 11.7250484],
      [104.925386799999998, 11.724300400000001],
      [104.923700199999999, 11.7234306],
      [104.922198199999997, 11.722733099999999],
      [104.920957900000005, 11.7221742],
      [104.9192714, 11.721560699999999],
      [104.917838000000003, 11.7199513],
      [104.916553800000003, 11.717791399999999],
      [104.915277200000006, 11.7155855],
      [104.912561400000001, 11.7122657],
      [104.911460399999996, 11.710001099999999],
      [104.910874100000001, 11.7084499],
      [104.910110799999998, 11.704827699999999],
      [104.909406000000004, 11.701159199999999],
      [104.908854899999994, 11.699343600000001],
      [104.906818299999998, 11.6968853],
      [104.904033299999995, 11.694530800000001],
      [104.900436999999997, 11.691447800000001],
      [104.900256799999994, 11.690534400000001],
      [104.899841199999997, 11.688404800000001],
      [104.898525800000002, 11.686992099999999],
      [104.897825400000002, 11.685280300000001],
      [104.898440399999998, 11.6847502],
      [104.898793299999994, 11.6845049],
      [104.899532100000002, 11.683991199999999],
      [104.899719300000001, 11.683861],
      [104.899498500000007, 11.6830812],
      [104.899647700000003, 11.672421099999999],
      [104.898408399999994, 11.6725247],
      [104.896415099999999, 11.6724788],
      [104.893843200000006, 11.672520799999999],
      [104.891293300000001, 11.672541300000001],
      [104.885230000000007, 11.672325300000001],
      [104.884653099999994, 11.6723047],
      [104.878176100000005, 11.6726525],
      [104.875184700000005, 11.672641],
      [104.871300599999998, 11.672654],
      [104.870695100000006, 11.6726718],
      [104.867946500000002, 11.6727542],
      [104.867346400000002, 11.672741500000001],
      [104.863888399999993, 11.672668099999999],
      [104.862665899999996, 11.672642099999999],
      [104.860137800000004, 11.670337699999999],
    ],
    name: 'Chroy Changvar',
    color: '#0d47a1',
  },
  // 'Prek-Pnov': {
  //   coordinates: [],
  //   name: '',
  // color: '',
  // },
  'Chbar-Ampov': {
    coordinates: [
      [104.932730599999999, 11.5315999],
      [104.931788299999994, 11.533977999999999],
      [104.931409000000002, 11.536035200000001],
      [104.931835000000007, 11.5382376],
      [104.933272000000002, 11.5399083],
      [104.935296399999999, 11.5410501],
      [104.937935999999993, 11.5417539],
      [104.941359599999998, 11.543139399999999],
      [104.944717499999996, 11.545870000000001],
      [104.945366800000002, 11.546719700000001],
      [104.946412600000002, 11.548508399999999],
      [104.9468356, 11.549429200000001],
      [104.947102700000002, 11.550677500000001],
      [104.948286100000004, 11.5597367],
      [104.956358499999993, 11.552393500000001],
      [104.965979300000001, 11.5483282],
      [104.978566799999996, 11.546317699999999],
      [105.007933699999995, 11.544921799999999],
      [105.028537400000005, 11.542516600000001],
      [105.037729900000002, 11.539615400000001],
      [105.040668600000004, 11.5380495],
      [105.040626599999996, 11.536322999999999],
      [105.030935099999994, 11.5242907],
      [105.028956699999995, 11.522133999999999],
      [105.027102799999994, 11.518737099999999],
      [105.026284099999998, 11.515668],
      [105.026900100000006, 11.5122856],
      [105.027499800000001, 11.507835999999999],
      [105.027839700000001, 11.5056802],
      [105.028168199999996, 11.5035594],
      [105.028235699999996, 11.502102300000001],
      [105.028390799999997, 11.500495799999999],
      [105.028295299999996, 11.499436599999999],
      [105.028159299999999, 11.497607500000001],
      [105.028151199999996, 11.4943993],
      [105.029026000000002, 11.491232800000001],
      [105.0290873, 11.488082199999999],
      [105.029311199999995, 11.4835309],
      [105.034512000000007, 11.475784300000001],
      [105.0319729, 11.471686099999999],
      [105.031040200000007, 11.4671922],
      [105.030837099999999, 11.466139500000001],
      [105.026047800000001, 11.466806099999999],
      [105.012872799999997, 11.467383399999999],
      [105.003475899999998, 11.466163099999999],
      [104.995025299999995, 11.4640307],
      [104.983510600000002, 11.4619067],
      [104.970345300000005, 11.4634198],
      [104.967063800000005, 11.4643867],
      [104.964154300000004, 11.465622400000001],
      [104.962252500000005, 11.4673008],
      [104.953610999999995, 11.479946],
      [104.946337900000003, 11.4946255],
      [104.935755999999998, 11.524108999999999],
      [104.932730599999999, 11.5315999],
    ],
    name: 'Chbar Ampov',
    color: '#33691e',
  },
}

export default districts



// WEBPACK FOOTER //
// ./src/config/district.js